// extracted by mini-css-extract-plugin
export default {"Container":"Container_Container__bBfgt","full":"Container_full__qPsB6"};